export default {"src":"/blog/_next/static/media/youtube.3b2df2c4.svg","height":800,"width":800};